export const camelCaseToFlat = (str: string) => str.replace(/([a-z])([A-Z])/g, '$1 $2').split(" ").join(" ");

export const camelToSnakeCase = (str: string) => str.replace(/[A-Z]/g, letter => `_${letter.toLowerCase()}`);